const MeasureType = {
  HEIGHT: 1,
  WEIGHT: 0,
};

export default MeasureType;
